
import { Vue, Options, Prop } from 'vue-property-decorator';

import MaterialButton from './Button.vue';

@Options({
    components: {
        MaterialButton
    }
})
export default class MaterialDialogAction extends Vue {
    @Prop(String) readonly action?: string;
    @Prop(Boolean) readonly asDefault?: boolean;
    @Prop(String) readonly text!: string;
}
